<template>
  <div>
    <v-card class="pa-0 pb-10" tile>
      <v-card-title>
        <h4 class="primary--text">
          {{ $t('spedilink.myLinks.title') }}
        </h4>
      </v-card-title>

      <div class="background px-6 my-4">
        <v-tabs
          v-model="activeTab"
          :height="60"
          background-color="background"
          show-arrows
          hide-slider
          center-active
        >
          <v-tab>{{ $t('spedilink.myLinks.cargo') }}</v-tab>
          <v-tab>{{ $t('spedilink.myLinks.vehicle') }}</v-tab>
        </v-tabs>
      </div>

      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-card class="py-5">
            <SpedilinkLinksTable
              ref="cargoTable"
              :type="1"
              @create="openCreateDialog()"
            />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="py-5">
            <SpedilinkLinksTable
              ref="vehicleTable"
              :type="2"
              @create="openCreateDialog()"
            />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <CreateSpedilinkLinkDialog
      v-model="createDialog"
      :type="activeTab === 0 ? 1 : 2"
      @link-created="onLinkCreated()"
      @close="createDialog = false"
    />
  </div>
</template>

<script>
import SpedilinkLinksTable from '@/views/Spedilink/tables/SpedilinkLinksTable'
import CreateSpedilinkLinkDialog from '@/views/Spedilink/dialogs/CreateSpedilinkLinkDialog'

export default {
  name: 'SpedilinkMyLinks',
  components: {
    SpedilinkLinksTable,
    CreateSpedilinkLinkDialog
  },
  data () {
    return {
      activeTab: 0,
      createDialog: false
    }
  },
  mounted () {
    this.syncTabFromRoute()
  },
  watch: {
    '$route.query.tab' () {
      this.syncTabFromRoute()
    },
    activeTab (newTab) {
      if (newTab === 0 && this.$refs.cargoTable) {
        this.$refs.cargoTable.loadLinks()
      } else if (newTab === 1 && this.$refs.vehicleTable) {
        this.$refs.vehicleTable.loadLinks()
      }
    }
  },
  methods: {
    syncTabFromRoute () {
      const t = this.$route.query.tab
      if (t === 'vehicle') {
        this.activeTab = 1
      } else if (t === 'cargo') {
        this.activeTab = 0
      }
    },
    openCreateDialog () {
      this.createDialog = true
    },
    async onLinkCreated () {
      this.createDialog = false
      const table = this.activeTab === 0 ? this.$refs.cargoTable : this.$refs.vehicleTable
      if (table) {
        await table.loadLinks()
      }
    }
  }
}
</script>

<style scoped>
.v-tab::before {
  display: block;
  content: attr(title);
  font-weight: bold;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}

.v-tab:hover {
  color: var(--v-primary-base) !important;
  text-shadow: 0 0 .7px var(--v-primary-base), 0 0 .7px var(--v-primary-base);
}

.v-tab--active:hover,
.v-tab--active {
  font-weight: bold;
  color: var(--v-primary-base) !important;
  text-shadow: none;
}

.v-tab {
  border-left: solid 1px var(--v-separator-base);
  margin: 10px 0;
}

.v-tab:last-child {
  border-right: solid 1px var(--v-separator-base);
  margin: 10px 0;
}
</style>
